import * as MessageFreqConstants from './MessageFreqConstants';
import {
    STATUS_FAILURE,
    STATUS_PENDING,
    STATUS_SUCCESS,
  } from "Common/constants/commonConstants";
import { produce } from "immer";
// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require('object.assign');

const initialState ={
    msgFreqMode:MessageFreqConstants.LIGHTNING,
    fetchStatus:STATUS_SUCCESS,
    updateStatus:STATUS_SUCCESS,
    isOptimized:false
};

const getMode = (mode) => (mode === MessageFreqConstants.LIGHTNING) ? MessageFreqConstants.NORMAL : MessageFreqConstants.LIGHTNING;

export default function MessageFreqReducer(state = initialState, action) {

    switch (action.type) {
        case MessageFreqConstants.MESSAGE_FQY_MODE_UPDATING:{
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        updateStatus:STATUS_PENDING
                    };
                }
            });
            return assign({}, state, newState);
        }
        case MessageFreqConstants.MESSAGE_FQY_MODE_UPDATED_SUCCESS:{
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        updateStatus:STATUS_SUCCESS,
                        msgFreqMode: getMode(action.payload.mode)
                    };
                }
            });
            return assign({}, state, newState);
        }
        case MessageFreqConstants.MESSAGE_FQY_MODE_UPDATED_FAILED: {
            const newState = produce(state, (draft) => {
                if(draft[action.payload.instanceId]) {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        updateStatus:STATUS_FAILURE
                    };
                }
            });
            return assign({}, state, newState);
        }

        case MessageFreqConstants.MESSAGE_FQY_MODE_FETCHING: {
            const newState = produce(state, (draft) => {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        fetchStatus:STATUS_PENDING
                    };
            });
            return assign({}, state, newState);
        }

        case MessageFreqConstants.MESSAGE_FQY_MODE_FETCHED_SUCCESS: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    fetchStatus:STATUS_SUCCESS,
                    isOptimized:action.payload.newState.result.optimized,
                    msgFreqMode: getMode(action.payload.newState.result.mode)
                };    
            });
            return assign({}, state, newState);
        }

        case MessageFreqConstants.MESSAGE_FQY_MODE_FETCHED_FAILED: {
            const newState = produce(state, (draft) => {
                    draft[action.payload.instanceId] = {
                        ...draft[action.payload.instanceId],
                        fetchStatus:STATUS_FAILURE
                    };
            });
            return assign({}, state, newState);
        }
         
        default:
        return state;

    }
}